import { Text } from '@trmediaab/zebra';
import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';

let uniqueId = 0;
const getUniqueId = () => uniqueId++;
const useUniqueId = prefix => {
  const idRef = useRef(getUniqueId());
  return `${prefix}_${idRef.current}`;
};

const BridleTooltip = ({ id, content }) =>
  content ? <Tooltip id={id}>{content}</Tooltip> : null;

export function Bridle({ data, tooltipEnabled = false, ...textProps }) {
  const tooltipId = useUniqueId('tooltip-bridle');

  if (data.value == null) {
    return <Text {...textProps}>-</Text>;
  }

  const tooltipContent = [
    data.isFirstTime ? 'För första gången.' : null,
    data.isChanged ? ` Senast: ${data.previousValue}.` : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Text
      fontWeight="medium"
      fontSize="0"
      lineHeight="1"
      maxWidth="fit-content"
      color={data.isChanged ? '#EB123A' : undefined}
      textDecoration={data.isChanged ? 'underline dotted #EB123A' : undefined}
      {...(tooltipEnabled && { 'data-tooltip-id': tooltipId })}
      {...textProps}
    >
      {data.value}
      {tooltipEnabled && (
        <BridleTooltip id={tooltipId} content={tooltipContent} />
      )}
    </Text>
  );
}
